module.exports = __webpack_public_path__ + "static/media/fbLogo.5e064713.svg";